
var productCardMarkup = `
        <div class="c-favourites">
        <div>
        <ul class="c-product-list c-favourites__list" data-qa-id="product-list" >
        {{#products}} 
            <li class="c-favourites-list-item c-favourites-list-item--has-border">
            <div class="c-favourites-list-item__content-wrapper">
            <div class="c-favourites-list-item__thumbnail-details-wrapper">
                <a class="c-favourites-list-item__thumbnail" href="{{du}}">
                    <picture class="c-picture">
                    <img src="{{iu}}" />
                    </picture>
                </a>
                <div class="c-favourites-list-item__details">
                    <div class="c-favourites-list-item__header">
                        <a class="c-favourites-list-item__product-name" href="{{du}}">
                        <h2 class="c-heading c-favourites-list-item__product-name u-text-thin"><span class="c-markdown">{{dt}}</span></h2>
                        </a>
                        <div class="c-favourites-list-item__header-inner">
                        <a class="c-favourites-list-item__product-price" href="{{du}}"><span aria-label="Price: ₱{{pr}}" class="c-favourites-list-item__final-price u-text-thin">₱{{pr}}</span></a>
                        <div class="c-favourites-list-item__product-cta"><button data-variant-id="{{epi}}" data-product-id="{{empi}}" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" aria-disabled="false" aria-label="{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}" class="u-btn u-btn--primary u-btn--has-wide-padding c-favourites-list-item__edit-sizes-btn" type="button" id="swym-custom-add-toCartBtn"><span class="u-btn__content">{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}</span></button></div>
                        </div>
                    </div>
                    <div class="c-favourites-list-item__choices-actions-wrapper">
                        <ul class="c-favourites-list-item__choice-list">
                        <li class="c-favourites-list-item__choice"><a href="{{du}}">{{variantinfo}}</a></li>
                        </ul>
                        <ul class="c-favourites-list-item__edit-actions-list">
                        <li class="c-favourites-list-item__edit-action"><button aria-disabled="false" aria-label="Remove item {{dt}}" class="u-btn u-btn c-favourites-list-item__remove-button o-list-item__edit-btn" type="button" id="swym-remove-productBtn" data-variant-id="{{epi}}" data-product-id="{{empi}}"><span class="u-btn__content">Remove</span></button></li>
                        </ul>
                    </div>
                    
                </div>
            </div>
            </div>
        </li>
        {{/products}}</div></div>`;


var emptyWishlist = `<div class="c-favourites-empty">
                        <div>
                            <h2 class="c-heading c-favourites-empty__title">
                                <div class="c-favourites-empty__title--part1">You have no favourites yet.</div>
                                Add the product you like in your list by tapping on the
                                <svg aria-hidden="false" aria-label="heart" class="c-icon c-favourites-btn__icon c-favourites-btn__icon--line c-favourites-empty__icon" fill="currentColor" focusable="false" role="img" version="1.1" viewBox="0 0 82 82">
                                    <text class="c-icon--title">heart</text>
                                    <path d="M23.6 13.4c3.9 0 7.9 1.5 10.9 4.5l5.5 5.5c.6.6 1.6.6 2.3 0l5.4-5.4c6-6 15.7-6 21.8 0 6 6 6 15.7 0 21.7C59.9 49.1 50.4 58.5 41 68L12.7 39.6c-6-6-6-15.6 0-21.7 3-3 6.9-4.5 10.9-4.5zm0-3.3c-4.7 0-9.5 1.8-13.1 5.5-7.3 7.3-7.2 19 0 26.3l29.4 29.5c.6.6 1.6.6 2.3 0C52 61.6 61.8 51.8 71.7 42c7.3-7.3 7.3-19.1 0-26.3s-19-7.3-26.3 0L41 19.9l-4.3-4.3c-3.6-3.6-8.4-5.5-13.1-5.5z"></path>
                                </svg>
                                <span class="c-markdown">icon on the product.</span>
                            </h2>
                        </div>
                        </div>`;

    

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
        var wishlistContentsContainer = document.getElementById("wishlist-items-container");
        console.log("products",products.length)
		if(products.length > 0) {
            if($("[data-fav-count]").length > 0) $("[data-fav-count]").text(`(${products.length})`)
        } else {
            if($("[data-fav-count]").length > 0) $("[data-fav-count]").text("")
            wishlistContentsContainer.innerHTML = emptyWishlist;
        }
		
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer && products.length > 0){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  console.log("Container not found, Wishlist Page element not found");
		}
		
	});
}

function onAddToCartClick(e) {
	e.preventDefault();
    
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
    
    if(e.target.dataset.stateCart != "" && e.target.dataset.stateCart !== undefined) {
        document.querySelector(".c-shopping-bag__button").click()
    } else {
        e.target.innerHTML = "Adding..";
        window._swat.replayAddToCart({
            empi: productId,
            du: du
        }, variantId, function(c) {
            // window._swat.getProductDetails(
            //     { id: variantId, empi: productId, du: du },
            //     function(productJson) {
            //       console.log("Entire product json:", productJson);
            //       window.theme.cart.items.push(productJson)
            //       window.cisFunc.Cart.updateCartItems()
            //     },
            //     function(e) {
            //       console.log(e);
            //     }
            //   );
            e.target.innerHTML = "Added to Cart";
            e.target.setAttribute("data-state-cart", "swym-added");
            location.reload();
            // document.querySelector(".c-shopping-bag__button").click()
        }, function(e) {
            console.log(e);
        });
    }
	
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	// console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
                    
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}